import { call } from "./call";

export const send = (info, successCallback, errorCallback) =>
  call(
    "/test-drives",
    {
      method: "POST",
      body: JSON.stringify({
        test_drive: {
          first_name: info.firstName,
          last_name: info.lastName,
          phone: info.phone,
          email: info.email,
          message: info.message,
          overage: info.overage,
        },
      }),
    },
    successCallback,
    errorCallback
  );



// WEBPACK FOOTER //
// ./src/api/testDrives.js